import React from 'react'

function Presentation() {
    return (
        <div id='presentation'>
            <h1>UI Presentation</h1>
            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium.</p>
        </div>
    )
}

export default Presentation
